import io from "socket.io-client";

const URL = import.meta.env.VITE_API_URL;

export const initSocket = () =>
    io(URL, {
        autoConnect: false,
        reconnection: true,
        transports: ["websocket"]
    });
